import Api from "../../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actionsEprofileEletmod: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új bejegyzés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newEprofileEletmodRow'
            }
        ],
        searchFields: [
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                formSize: 4,
                formType: "text"
            },
            {
                name: "breakGlass",
                label: "Sürgősségi adatlekérés",
                formType: "checkbox",
                formSize: 4
            },
            {
                name: "breakGlassOk",
                label: "Sürgősségi adatlekérés oka",
                formType: "text",
                formSize: 4
            }
        ],
        formActionsEprofileEletmod: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToEprofileEletmodGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetEprofileEletmodForm'
            }
        ],
        rowActionsEprofileEletmod: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyEprofileEletmodRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteEprofileEletmodRow'
            }
        ],
        headerFieldsEprofileEletmod: [
            {
                name: "betegIdErtek",
                label: "Beteg ID érték",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "betegIdTipus",
                label: "Beteg ID típus",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "hitelesito",
                label: "Hitelesítő",
                description: "ENKK nyilvántartási szám, pl: 12345",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "megfigyelo",
                label: "Megfigyelő",
                description: "ENKK nyilvántartási szám, pl: 12345",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "leiras",
                label: "Leírás",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
            {
                name: "bizonyossag",
                label: "Bizonyosság",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getBizonyossagList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "onrendelkezesiKategoria",
                label: "Önrendelkezési kategória",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getOnrendelkezesList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "eesztid",
                label: "EESZT ID",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "verzio",
                label: "Verzió",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "eletmodKod",
                label: "Életmód kód",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEletmodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "eletmod",
                label: "Életmód",
                filter: {
                    type: "simple",
                },
            },
            {
                name: "idoszak",
                label: "Időszak",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "megfigyelesErteke",
                label: "Megfigyelés értéke",
                filter: {
                    type: "simple",
                },
                formRequired: true,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
